var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1182.33 905.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#35a8e0;opacity:0.4;}.cls-2{fill:#3257a4;opacity:0.6;}.cls-3,.cls-4{fill:none;}.cls-4,.cls-5{stroke:#e73249;stroke-linecap:round;stroke-linejoin:round;stroke-width:40px;}.cls-5{fill:#e73249;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1182.33,
    height: 905.45,
    rx: 84.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M953.6,434.42c-7.91-7.3-195.56-179.35-362.44-179.35S236.64,427.12,228.73,434.42a25,25,0,0,0,0,36.6c7.91,7.32,195.56,179.36,362.43,179.36S945.69,478.34,953.6,471a25,25,0,0,0,0-36.6ZM430,552.22c-63-33.31-117.66-75.71-146.25-99.49C312.37,428.94,367,386.56,430,353.24a189,189,0,0,0,0,199Zm161.13,40.11c-77,0-139.6-62.64-139.6-139.6s62.62-139.6,139.6-139.6,139.61,62.63,139.61,139.6S668.15,592.33,591.16,592.33Zm161.13-40.11a188.92,188.92,0,0,0,0-199c63,33.32,117.66,75.7,146.26,99.49C870,476.51,815.29,518.91,752.29,552.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M591.16,386.66a66.07,66.07,0,1,0,66.09,66.07A66.15,66.15,0,0,0,591.16,386.66Zm0,82.26a16.2,16.2,0,1,1,16.22-16.19A16.24,16.24,0,0,1,591.16,468.92Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 701.54,
    y1: 209.55,
    x2: 701.54,
    y2: 151.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "591.16 407.88 591.16 441.73 591.16 463.72 591.16 497.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 591.16,
    y1: 491.71,
    x2: 591.16,
    y2: 413.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M591.16,66.85v133"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M641,116.71,592.61,68.29h0a2,2,0,0,0-2.89,0h0L541.3,116.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M591.16,838.61v-133"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M541.3,788.74l48.42,48.42h0a2,2,0,0,0,2.89,0h0L641,788.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.74,86.32l94,94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.27,86.32H222.79a2,2,0,0,0-2,2.05h0v68.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M961.58,86.32l-94,94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M891.06,86.32h68.48a2,2,0,0,1,2,2.05h0v68.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.74,835.76l94-94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.27,835.76H222.79a2,2,0,0,1-2-2h0V765.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M961.58,835.76l-94-94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M891.06,835.76h68.48a2,2,0,0,0,2-2h0V765.24"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlex);
export default __webpack_public_path__ + "static/media/Flex.d4cf06a2665d28a7b02615051392bfaf.svg";
export { ForwardRef as ReactComponent };